// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22ZB2","tabsBox":"styles_tabsBox__TdxE0","createButton":"styles_createButton__29xHm"};